import React, { Component } from 'react';
import { Spin } from 'antd';
import styles from './sa-feed.module.sass';
import FeedList from './FeedList';
import FeedDetails from './FeedDetails';
import { STATUS } from '../../../../redux/constants';

class SAFeed extends Component {
  static getDerivedStateFromProps(props, state) {
    if (
      state.saveStatus === STATUS.RUNNING &&
      props.saveStatus === STATUS.SUCCESS
    ) {
      return {
        saveStatus: props.saveStatus,
        showCreateForm: false,
      };
    }
    return {
      saveStatus: props.saveStatus,
    };
  }

  componentDidMount() {
    document.title = 'Feeds - Silent Push';
    if (!this.props.showCreateForm) {
      this.props.loadGlobalFeeds();
    }
  }

  state = {
    saveStatus: STATUS.IDLE,
    selectedFeed: null,
    showCreateForm: this.props.showCreateForm ?? false,
  };

  handleFeedItemEdit = (selectedFeed) => {
    this.setState({ selectedFeed, showCreateForm: true });
  };

  handleFeedItemAdd = () => {
    this.setState({ selectedFeed: null, showCreateForm: true, error: false });
  };

  handleFeedItemDelete = (feed) => {
    this.props.deleteGlobalFeed(feed);
  };

  handleDetailsClose = () => {
    this.setState({ selectedFeed: null, showCreateForm: false });
    this.props.resetFeedStatus();
  };

  renderDetails = () => {
    const { selectedFeed } = this.state;
    return (
      <FeedDetails
        loadFeeds={this.props.loadFeeds}
        feed={selectedFeed}
        onCancel={this.handleDetailsClose}
        feedTable={this.props.feedTable}
        consumeStatus={this.props.consumeStatus}
        saveStatus={this.props.saveStatus}
        testStatus={this.props.testStatus}
        message={this.props.message}
        feedItemFields={this.props.feedItemFields}
        consumeFeedData={this.props.consumeFeedData}
        consumeFileData={this.props.consumeFileData}
        createGlobalFeed={this.props.createGlobalFeed}
        updateGlobalFeed={this.props.updateGlobalFeed}
        verifyAuth={this.props.verifyAuth}
        resetFeedStatus={this.props.resetFeedStatus}
        createVirtualFeed={this.props.createVirtualFeed}
        updateVirtualFeed={this.props.updateVirtualFeed}
        handleDetailsClose={this.handleDetailsClose}
        searchForTags={this.props.searchForTags}
        resetTagSearch={this.props.resetTagSearch}
        foundTags={this.props.foundTags}
        searchStatus={this.props.searchStatus}
      />
    );
  };

  renderList = () => {
    return (
      <FeedList
        resetFeedStatus={this.props.resetFeedStatus}
        onItemEdit={this.handleFeedItemEdit}
        onItemAdd={this.handleFeedItemAdd}
        onItemDelete={this.handleFeedItemDelete}
        globalFeeds={this.props.globalFeeds}
        status={this.props.status}
        updateGlobalFeed={this.props.updateGlobalFeed}
        updateVirtualFeed={this.props.updateVirtualFeed}
        user={this.props.user}
      />
    );
  };

  render() {
    console.log(this.props.error);
    const { showCreateForm, status } = this.state;
    const isLoading = status === STATUS.LOADING;
    return (
      <div className={styles.container}>
        {isLoading && <Spin style={{ margin: 40 }} />}
        {!isLoading &&
          showCreateForm &&
          !this.props.error &&
          this.renderDetails()}
        {!isLoading &&
          showCreateForm &&
          this.props.error &&
          this.renderDetails()}
        {!isLoading && !showCreateForm && this.renderList()}
      </div>
    );
  }
}

export default SAFeed;
